import { Cookies } from 'react-cookie';

import { EncUpdateAfterBlitzFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface PutEncAfterBlitzProps {
  encId: number;
  enc: EncUpdateAfterBlitzFormValues;
  objectSlug: string;
}

export const putEncAfterBlitz = async ({ encId, enc, objectSlug }: PutEncAfterBlitzProps) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const data = await axiosInterceptor.put(`/encounters/${objectSlug}/${encId}/complete-encounter-after-blitz/`, enc, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data as any;
};
